import { COMMON_NAMESPACE } from '@porsche-code/kado-i18n';
import { Spacer } from '@porsche-code/kado-ui';
import { PHeading } from '@porsche-design-system/components-react';
import { createFileRoute } from '@tanstack/react-router';
import { Trans, useTranslation } from 'react-i18next';

import { ContactCard, Paragraph } from '@/components';

export const Route = createFileRoute('/help')({
  component: Help,
  beforeLoad: () => {
    return {
      breadcrumb: () => <Trans i18nKey="footer.help" ns={COMMON_NAMESPACE} />,
    };
  },
});

function Help() {
  const { t } = useTranslation();

  const personsInCharge = [
    {
      name: 'Patrick Ott',
      role: 'KADO Project Manager',
      phone: '+49 170 911 – 8963',
      mail: 'patrick.ott@porsche.de',
    },
    {
      name: 'General KADO Support',
      mail: 'kado@porsche.de',
    },
  ];

  return (
    <>
      <PHeading size="lg" aria-level={1} tag="h1">
        {t('helpArea.title')}
      </PHeading>
      <Spacer mb="md" />
      <PHeading size="md" tag="h2">
        {t('helpArea.personsInCharge')}
      </PHeading>
      <Paragraph>{t('helpArea.personsInChargeIntro')}</Paragraph>
      {personsInCharge.map((person) => (
        <ContactCard key={person.name} {...person} />
      ))}
    </>
  );
}
